import { FC } from 'react'
import { useQuery } from '@apollo/client'

import { calculateQtyValuesFromMinMaxSplit } from 'components/contexts/event-page-filters/utils'
import { useActions as useEventPageActions } from 'components/contexts/event-page'
import { useActions as useFilterActions } from 'components/contexts/event-page-filters'
import { formatCurrency, getIdFromSlug } from 'utils'
import { GetEventAuctionByIdQuery, GrantedPackagesQuery } from 'gql'
import { Flex, Spinner } from 'components/ui'
import { useDataLayer } from 'hooks'

import { GET_EVENT_AUCTION_BY_ID } from 'gql/artwork/queries'
import Ticket from './ticket'

type GrantedTickets = {
  data?: Array<GrantedPackagesQuery['allPackages']['edges'][0]['node']>
  artworkSlug: string
  loading?: boolean
}

const GrantedTickets: FC<GrantedTickets> = ({ artworkSlug, data, loading }) => {
  const { data: eventData } = useQuery<GetEventAuctionByIdQuery>(GET_EVENT_AUCTION_BY_ID, {
    variables: {
      pk: getIdFromSlug(artworkSlug),
    },
  })

  const { onAddToCheckout } = useEventPageActions()
  const { setFormQuantityOptions } = useFilterActions()

  const dl = useDataLayer()

  if (loading) {
    return (
      <Flex padding="1rem" justifyContent="center">
        <Spinner />
      </Flex>
    )
  }

  return (
    <>
      {data.map((item) => (
        <Ticket
          quantity={item.availableQuantity}
          onClick={() => {
            const availableQuantity = Math.min(item.maxSplit, item.availableQuantity)

            setFormQuantityOptions(
              calculateQtyValuesFromMinMaxSplit(
                Math.min(item.minSplit, availableQuantity),
                availableQuantity
              )
            )

            onAddToCheckout({
              deliveryNotes: item.deliveryNotes,
              price: `${formatCurrency(item.price, 0)}/ea`,
              unformatedPrice: item.price,
              longDescription: item.longDescription,
              title: item.name,
              messages: [],
              checkoutPayload: {
                packageId: item.id,
              },
            })

            const event = eventData.findArtwork || ({} as GetEventAuctionByIdQuery['findArtwork'])

            dl.push({
              event: 'view_item',
              ecommerce: {
                currency: 'USD',
                value: item.price,
                item_list_name: 'tickets',
                items: [
                  {
                    item_name: item.name,
                    item_id: item.pk,
                    star_name: event.mainArtist?.fullName,
                    event_date: event.eventStartDateLocal,
                    venue_name: event.venue?.name,
                    tour_name: event.tour?.title,
                    event_name: event.title,
                  },
                ],
              },
            })
          }}
          price={item.price}
          title={item.name}
          key={item.id}
        />
      ))}
    </>
  )
}

export default GrantedTickets
